export const getDetailPath = (basePath: string, id: string|number) => {
    return `${basePath}/${id}`;
}

export const getNewPath = (basePath: string) => {
    return `${basePath}/new`;
}